import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  Button,
  Box,
} from "@material-ui/core";
import { AppConfig } from "app-config";
import CircularProgress from "@material-ui/core/CircularProgress";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import { Pagination } from "@material-ui/lab";
import moment from "moment";

const columns = [
  { id: "name", label: "Application Type", minWidth: 170 },
  { id: "application", label: "Applicant Contact", minWidth: 100 },
  {
    id: "date",
    label: "Revenue",
    minWidth: 170,
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "status",
    label: "Renewal Timeline",
    minWidth: 170,
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "action",
    label: "Remitta Code",
    minWidth: 170,
    align: "left",
    format: (value) => value.toFixed(2),
  },
];

function createData(name, application, date, status, code) {
  return { name, application, date, status, code };
}

const rows = [
  createData(
    "Operating License",
    "07017372949",
    "$500,000",
    "08/10/2022",
    "35829452058",
  ),
  createData(
    "Operating License",
    "07017372949",
    "$500,000",
    "08/10/2022",
    "35829452058",
  ),
  createData(
    "Operating License",
    "07017372949",
    "$500,000",
    "08/10/2022",
    "35829452058",
  ),
  createData(
    "Operating License",
    "07017372949",
    "$500,000",
    "08/10/2022",
    "35829452058",
  ),
  createData(
    "Operating License",
    "07017372949",
    "$500,000",
    "08/10/2022",
    "35829452058",
  ),
  createData("Buzza Company", "OPL Application renewal", "08/10/2022", "Paid"),
  createData(
    "Operating License",
    "07017372949",
    "$500,000",
    "08/10/2022",
    "35829452058",
  ),
  createData(
    "Operating License",
    "07017372949",
    "$500,000",
    "08/10/2022",
    "35829452058",
  ),
  createData(
    "Operating License",
    "07017372949",
    "$500,000",
    "08/10/2022",
    "35829452058",
  ),
  createData(
    "Operating License",
    "07017372949",
    "$500,000",
    "08/10/2022",
    "35829452058",
  ),
  createData(
    "Operating License",
    "07017372949",
    "$500,000",
    "08/10/2022",
    "35829452058",
  ),
  createData(
    "Operating License",
    "07017372949",
    "$500,000",
    "08/10/2022",
    "35829452058",
  ),
  createData(
    "Operating License",
    "07017372949",
    "$500,000",
    "08/10/2022",
    "35829452058",
  ),
  createData(
    "Operating License",
    "07017372949",
    "$500,000",
    "08/10/2022",
    "35829452058",
  ),
  createData(
    "Operating License",
    "07017372949",
    "$500,000",
    "08/10/2022",
    "35829452058",
  ),
];

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  ent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  container: {
    maxHeight: 440,
    marginTop: "2rem",
  },
  paper: {
    // padding: theme.spacing(2),
    color: "black",
    // minHeight: "150px",
    width: "100%",
    padding: "1rem 2rem",
  },
  editButton: {
    background: "#47BB78",
    border: "none",
    color: "white",
    textTransform: "capitalize",
    "&:hover": {
      background: "#47BB78",
      border: "none",
      color: "white",
    },
  },
  link: {
    background: "#47BB78",
    color: "white",
    padding: "5px 1px",
    borderRadius: "5px",
  },
  paginated: {
    backgroundColor: "white",
    marginTop: "15px",
    display: "flex",
    justifyContent: "space-between",
    paddingInline: "60px",
    paddingBlock: "18px",
  },
  spinner: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "1rem",
    height: "100%",
  },
});

const StickyHeadTable = () => {
  const classes = useStyles();
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [step, setStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [revenue, setRevenue] = useState([]);
  const [lastPage, setLastPage] = useState(0);
  const [paginated, setPaginated] = useState(false);
  const [page, setPage] = useState(1);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setPaginated(true);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const Previous = (e) => {
    e.preventDefault();
    prevState();
  };

  const Next = (e) => {
    e.preventDefault();
    nextStep();
  };

  const nextStep = () => {
    setStep(step + 1);
  };

  const prevState = () => {
    setStep(step - 1);
  };

  const formatDate = (date) => {
    const options = {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
    };
    if (date) {
      return new Date(date).toLocaleDateString(undefined, options);
    }
    return null;
  };

  //get user data from local storage
  const user = localStorage.getItem("userDetails");
  const userData = JSON.parse(user);

  const roleId = userData.data.role_id;

  console.log("ROLE_ID", roleId);

  const fetchRevenues = async () => {
    setLoading(true);
    let url = `${AppConfig.URL}/zone-admin/revenue`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${userData?.access_token}`,
        },
      });
      const { status, message, data } = await response.json();
      if (status) {
        setLoading(false);
        setRevenue(data?.data);
        setLastPage(data.last_page);
      }
    } catch (err) {
      console.log(err);
    }
  };
  //format as money code
  const formatAsMoney = (fee) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(fee);
  };

  useEffect(() => {
    fetchRevenues();
  }, [page]);

  return (
    <>
      <Paper className={classes.paper}>
        <div className={classes.ent}>
          <div>
            <Typography style={{ fontSize: "1.2rem" }}>
              Revenue Generated
            </Typography>
          </div>

          <div>
            <form>
              <select
                id="cat"
                name="cat"
                style={{
                  padding: "0.8rem 1.2rem",
                  border: "1px solid black",
                }}
              >
                <option value="volvo">Sort by ...</option>
                <option value="name">Name</option>
                <option value="date">Date</option>
              </select>
            </form>
          </div>
        </div>
        {loading ? (
          <Box className={classes.spinner}>
            <CircularProgress />
          </Box>
        ) : (
          <TableContainer className={classes.container}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth, color: "#B0AEAE" }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {revenue?.map((row) => (
                  <TableRow key={row?.id}>
                    <TableCell component="th" scope="row">
                      {row?.application_type}
                    </TableCell>
                    {/* <TableCell align="left">
                      {formatDate(row?.opl_renewal_date)}
                    </TableCell> */}
                    <TableCell align="left">{row?.applicant_phone}</TableCell>
                    <TableCell align="left">
                      {formatAsMoney(row?.fee)}
                    </TableCell>
                    {/* <TableCell align="center">
                      <Typography
                        style={{
                          textAlign: "left",
                          fontSize: "13px",
                          textTransform: "capitalize",
                        }}
                      >
                        {row?.applicant_phone}
                      </Typography>
                    </TableCell> */}

                    <TableCell align="left">
                      {formatDate(row?.opl_renewal_date)}
                    </TableCell>

                    <TableCell align="center">
                      <Typography
                        style={{
                          textAlign: "left",
                          fontSize: "13px",
                          textTransform: "capitalize",
                        }}
                      >
                        {row?.remitta_code}
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Paper>

      <Box className={classes.paginated}>
        <Button onClick={Previous} color="default" className={classes.btn}>
          <span style={{ marginRight: "5px" }}>
            <ArrowBackIcon />
          </span>
          Previous
        </Button>
        <Pagination
          component="Box"
          count={lastPage}
          onChange={handleChangePage}
          page={page}
          classes={{ ul: classes.ul }}
          color="standard"
        />
        <Button onClick={Next} color="default" className={classes.btn}>
          Next
          <span>
            <ArrowForwardIcon />
          </span>
        </Button>
      </Box>
    </>
  );
};

export default StickyHeadTable;
